import { TFunction } from 'i18next'

import { getDaysPastDeadline } from '@features/vatDeclarations/utils/getDaysPastDeadline'

import { VatDeclarationStatus } from '../../../enums/vatDeclarationStatus'

interface GetVatDeclarationDescriptionProps {
  reportDeadline: string
  vatDeclarationStatus: VatDeclarationStatus
  t: TFunction
}

export const getVatDeclarationDescription = ({
  reportDeadline,
  vatDeclarationStatus,
  t,
}: GetVatDeclarationDescriptionProps): string => {
  const isOverdue =
    vatDeclarationStatus === VatDeclarationStatus.OverduePayment ||
    vatDeclarationStatus === VatDeclarationStatus.OverdueSubmission
  const isReadyToSubmit = vatDeclarationStatus === VatDeclarationStatus.ReadyToSubmit
  const isReadyToPay = vatDeclarationStatus === VatDeclarationStatus.ReadyToPay
  const isSubmissionFailed = vatDeclarationStatus === VatDeclarationStatus.SubmissionFailed

  if (isSubmissionFailed) {
    return t('vat_declarations.table.description.submission_failed')
  }

  if (isOverdue) {
    const overdueByDays = getDaysPastDeadline(reportDeadline)

    return vatDeclarationStatus === VatDeclarationStatus.OverduePayment
      ? t('vat_declarations.table.description.payment_overdue', { days: overdueByDays })
      : t('vat_declarations.table.description.submission_overdue', { days: overdueByDays })
  }

  if (isReadyToSubmit) {
    return t('vat_declarations.table.description.ready_to_submit')
  }

  if (isReadyToPay) {
    return t('vat_declarations.table.description.ready_to_pay')
  }

  return ''
}
